import _ from 'lodash';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Player from '@vimeo/player';
import { FaSpinner } from "react-icons/fa";
import { useQueryClient, useQuery } from 'react-query'

import { gateway } from '../../../utils/api';
import eventBus from '../../../utils/eventBus';
import ViewEditor from '../../shared/ViewEditor';
import * as Styles from './styles';
import { Creators as VideoActions } from '../../../store/ducks/newCourse/actions';

const VideoV2 = ({
  description,
  selected,  
  setPlayerPosition,
  setCourseSelected,
  setDisciplineProgress,
  navigationContent,
  countFinishedObjects,
  countObjects,
  incrementCourseProgress,
  videoWidth = 800,
  videoHeight = 450,
  fromMobile = false,
  autoplayNextVideos = true
}) => {
  const playerContainerRef = useRef(null);
  const playerRef = useRef(null);
  const idProfile = useRef(parseInt(localStorage.getItem('idProfile'), 10));
  const ownderId =  localStorage.getItem('idProfile')
  const tenant = localStorage.getItem("tenant") || "";
  const homeCrCode = localStorage.getItem("defaultHomeCrCode") || "";
  const selectedClassCrCode = localStorage.getItem("selectedClassCrCode") || "";
  const haveUniqueObject = countObjects < 3
  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [loading, setLoading] = useState(true);
  const [refetchHome, setRefetchHome] = useState(true)
  const [videoPlayerUrl, setVideoPlayerUrl] = useState(null);
  const [openCount, setOpenCount] = useState(1);

  const countdownRef = useRef(null);
  const queryClient = useQueryClient();
  const getPlayedTime = useCallback(async () => {
    if (playerRef.current) {
      const time = await playerRef.current.getCurrentTime();
      return time || 0;
    }
    return 0;
  }, []);

  useEffect(() => {
    if (countFinishedObjects <= 3) setOpenCount(prev => prev + 1);
  }, [selected]); 

  useEffect(() => {
    setVideoPlayerUrl(null);
    setLoading(true);
  }, [selected.vimeo_url]);

  function extractVimeoId(url) {
    const regex = /vimeo\.com\/(?:video\/)?(\d+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  const { data: vimeoData } = useQuery(
      [`vimeoVideoUrl-${selected.vimeo_url}`],
     async () => {
      
      if (!selected.vimeo_url) return null;
       const videoId = extractVimeoId(selected.vimeo_url);
       const response = await gateway.get(`/gatewayout/vimeo/fetch-vimeo-video?idVideo=${videoId}`);
       setLoading(false);
        return response;
      },
       { enabled: !!selected.vimeo_url }
  );
  
  useEffect(() => {
     if (vimeoData && vimeoData.url) {
       setVideoPlayerUrl(vimeoData.url);
    }
   }, [vimeoData])

  const sendObjectProgress = useCallback(async (selected, action, status, playbackRate) => {
    try {
      const sessionCourse = localStorage.getItem('session');
      const time = await getPlayedTime();
      await gateway.post('/webbff/lit_app_web/course_progress/course_progress_object/', {
        selected: { code: selected.code, courseCode: selected.courseCode },
        idProfile: idProfile.current,
        courseSession: sessionCourse,
        action,
        status,
        type: 'VIDEO',
        mode: playbackRate,
        position: Math.floor(time) || 0,
      });
    } catch (error) {
      console.error('Erro ao enviar progresso do objeto:', error);
    }
  }, [getPlayedTime]);

  const startNextVod = () => {
    setCourseSelected(navigationContent.next);
    setShowModal(false);
    setCountdown(5);
  };

  const cancelNextVod = () => {
    setShowModal(false);
    clearTimeout(countdownRef.current);
    setCountdown(5);
  };

  const handleCountdown = () => {
    countdownRef.current = setTimeout(startNextVod, 5000);
    const intervalId = setInterval(() => {
      setCountdown(prevCountdown => {
        if (prevCountdown <= 1) {
          clearInterval(intervalId);
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);
  };

  const sendMobileEvent = (status) => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(status);
    } else {
      console.log('ReactNativeWebView não está disponível.');
    }
  }

  // Envia o tempo atual do vídeo para o app (WebView RN). O app usa esse valor
  // para preencher o minuto das anotações; sem isso, as anotações no app
  // ficavam sempre em 00:00.
  const sendMobileTime = (seconds) => {
    const currentTime = Number(seconds);
    if (window.ReactNativeWebView && Number.isFinite(currentTime)) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'VIDEO_PROGRESS', currentTime })
      );
    }
  };

  // timeupdate dispara várias vezes por segundo; limita a 1x/s para não
  // sobrecarregar a ponte RN <-> WebView.
  const throttledSendMobileTime = useRef(
    _.throttle((seconds) => sendMobileTime(seconds), 1000, {
      leading: true,
      trailing: true,
    })
  ).current;

  const isToPlayNextVideo = () => {
    const allowedTypes = ['VOD', 'VIDEO'];
    const type =
      navigationContent.next && navigationContent.next.media
        ? navigationContent.next.media.type
        : null;
    const isTypeVideo = allowedTypes.includes(type);
    return isTypeVideo && navigationContent.next && autoplayNextVideos;
  };

  const finishAttachment = async (action) => {
    if (isToPlayNextVideo()) {
      setShowModal(true);
      setCountdown(5);
      handleCountdown();
    }

    const progressFinished = {
      idProfile: idProfile.current,
      hierarchy: selected.hierarchy,
      contentCode: selected.code,
      courseCode: selected.courseCode,
      position: 0,
      status: 'DONE'
    };

    const objectStatusProgress = _.get(selected, 'contentProgress.ox_status.wk_status', 'IN_PROGRESS');
    await sendObjectProgress(selected, action, 'DONE', 1.0);

    const finishObject = await gateway.post('/webbff/lit_app_web/progress/saveProgress', progressFinished);
    queryClient.refetchQueries(`homeData-${ownderId}-${tenant}-${homeCrCode}-${selectedClassCrCode}`);
    if (objectStatusProgress !== 'DONE') {
      const progress = _.get(finishObject, 'progress', []);
      const foundObject = progress.find(p => p.rk_reference === selected.code);
      const status = _.get(foundObject, 'wk_status');
      incrementCourseProgress(status);
    }

    setDisciplineProgress(selected.idDiscipline);

    if (window.ReactNativeWebView) {
      sendMobileEvent('VIDEO_FINISHED'); // message for mobile app
    } else {
      document.getElementById(`course-object-${selected.code}`).classList.add('active');
    }
  };

  const saveProgress = useCallback(async (action) => {
    try {
      const time = await getPlayedTime();
      if (time > 0) {
        const progress = {
          idProfile: idProfile.current,
          hierarchy: selected.hierarchy,
          contentCode: selected.code,
          courseCode: selected.courseCode,
          position: Math.floor(time),
          status: 'IN PROGRESS',
        };
        setPlayerPosition(progress.position);
        if (refetchHome && (openCount === 3 || haveUniqueObject || countFinishedObjects >= 3)) {
          setRefetchHome(false);
          queryClient.refetchQueries(`homeData-${ownderId}-${tenant}-${homeCrCode}-${selectedClassCrCode}`);
      }
        await Promise.all([
          gateway.post('/webbff/lit_app_web/progress/saveProgress', progress),
          sendObjectProgress(selected, action, 'IN PROGRESS', await playerRef.current.getPlaybackRate())
        ]);
      }
    } catch (error) {
      console.error('Erro ao salvar progresso:', error);
    }
  }, [getPlayedTime, selected, sendObjectProgress, setPlayerPosition]);

  useEffect(() => {
    const unsubscribe = eventBus.on('SET_VIDEO_TIME', async (payload) => {
      try {
        const timeToSeek = payload && typeof payload.time === 'number' ? payload.time : null;
        if (timeToSeek != null && playerRef.current) {
          await playerRef.current.setCurrentTime(timeToSeek);
        }
      } catch (error) {
        console.error('Erro ao definir tempo do vídeo via eventBus:', error);
      }
    });

    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (videoPlayerUrl) {
      let player = null;

      const initializePlayer = async () => {
        if (playerRef.current) {
          try {
            await playerRef.current.destroy();
          } catch (error) {
            console.error('Erro ao destruir player anterior:', error);
          }
          playerRef.current = null;
        }

        const options = {
          url: videoPlayerUrl,
          autoplay: true,
          // playsinline garante reproducao inline no iOS (senao o Safari/WebView
          // do iOS forca o video para fullscreen). Combinado com
          // allowsInlineMediaPlayback na WebView do app.
          playsinline: true,
          responsive: !fromMobile,
          width: fromMobile ? window.innerWidth : videoWidth,
          height: fromMobile ? window.innerHeight : videoHeight,
          loop: false,
          byline: false,
          portrait: false,
        };

        try {
          player = new Player(playerContainerRef.current, options);
          playerRef.current = player;

          player.on('loaded', () => {
            setLoading(false);
          });

          if (_.get(selected, 'contentProgress.ox_status.nx_value')) {
            await player.setCurrentTime(_.get(selected, 'contentProgress.ox_status.nx_value'));
          }

          const debouncedSaveProgress = _.debounce(async (action) => {
            await saveProgress(action);
          }, 1000);

          const eventListeners = {
            play: () => saveProgress('STARTED'),
            pause: async () => {
              // Ao pausar, envia o tempo exato para o app antes de salvar,
              // para que uma anotação criada com o vídeo pausado use o minuto certo.
              const currentTime = await getPlayedTime();
              sendMobileTime(currentTime);
              saveProgress('PAUSED');
            },
            timeupdate: (data) => throttledSendMobileTime(_.get(data, 'seconds')),
            seeked: async () => {
              const currentTime = await getPlayedTime();
              setPlayerPosition(currentTime);
              sendMobileTime(currentTime);
              debouncedSaveProgress('ADVANCED');
            },
            ended: async () => {
              await player.setCurrentTime(0);
              await finishAttachment('DONE');
            }
          };

          Object.keys(eventListeners).forEach(event => 
            player.on(event, eventListeners[event])
          );
        } catch (error) {
          console.error('Erro ao inicializar player:', error);
          setLoading(false);
        }
      };

      initializePlayer();

      return () => {
        if (playerRef.current) {
          try {
            playerRef.current.destroy();
          } catch (error) {
            console.error('Erro ao destruir player no cleanup:', error);
          }
          playerRef.current = null;
        }
        throttledSendMobileTime.cancel();
        setShowModal(false);
        clearTimeout(countdownRef.current);
        setCountdown(5);
      };
    }
  }, [videoPlayerUrl, selected, getPlayedTime, saveProgress]);

  return (
    <div style={{ position: 'relative' }}>
      <div ref={playerContainerRef} style={{ width: '100%', height: 'auto' }}>
        {loading && !fromMobile && (<Styles.LoadingWrapper>
          <FaSpinner size={50} color="#38ade3" />

        </Styles.LoadingWrapper>)}
      </div>

      {showModal && !window.ReactNativeWebView && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
        }}>
          <div style={{ backgroundColor: '#fff', padding: '2.5em', borderRadius: '8px' }} className="w-50">
            <div className="row">
              <div className="col-12">
                <span>
                  <strong>O próximo vídeo inicia em {countdown} segundos</strong>
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <button onClick={startNextVod} className="btn btn-blue btn-block" type="button">
                  Próximo
                </button>
              </div>
              <div className="col-6">
                <button onClick={cancelNextVod} className="btn btn-cancel btn-block" type="button">
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {description && (
        <Styles.ObjectDescription>
          <ViewEditor data={description} />
        </Styles.ObjectDescription>
      )}

      {selected.knowMore.length > 0 && <h4>SAIBA MAIS - Arquivos</h4>}
      {selected.knowMore.length > 0 && selected.knowMore.map((item, index) => {
        const { media } = item;
        return (
          <Styles.ItemContainer key={index}>
            <Styles.ContainerIcon>{_.get(media, 'type', '?')}</Styles.ContainerIcon>
            <Styles.ItemDescription>
              {_.get(media, 'name', '?')}
            </Styles.ItemDescription>
            {_.get(media, 'path', false) && (
              <Styles.BtnDownload
                type="button"
                className="btn btn-light"
                onClick={() => this.downloadAnexo({ path: media.path })}
              >
                <i className="fa fa-download" aria-hidden="true" />
              </Styles.BtnDownload>
            )}
          </Styles.ItemContainer>
        );
      })}

    </div>
  );
};

const mapStateToProps = (state) => ({
  playerPosition: state.newCourse.playerPosition,
  navigationContent: state.newCourse.navigationContent,
  autoplayNextVideos: state.newCourse.autoplayNextVideos,
  countFinishedObjects: state.newCourse.data.countFinishedObjects,
  countObjects: state.newCourse.data.countObjects,
});


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(VideoActions, dispatch);


export default React.memo(connect(mapStateToProps, mapDispatchToProps)(VideoV2));
